












import { Component, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
@Component({
  name: "photon-notification-error-component",
})
export default class PhotonNotificationErrorComponent extends Vue {
  i18n = i18n;
}
